// 运营-报警列表api
import request from '@/util/request'
import axios from 'axios'
const CancelToken = axios.CancelToken
let cancel
export function cancelRequest () {
	if (typeof cancel === 'function') {
		// 取消请求
		cancel()
	  }
}

export function apiGetList(dir,ppt,size,page,data){ //电站列表
	if(data.plantIdList){
		data.plantId=data.plantIdList[0];//2019-03-15改成报警列表仅支持一个
		delete data.plantIdList;
	}
	return request({
		url: `/maintain-s/operating/alert/search`,
		method:"post",
		params:{
			"order.direction":dir,
			"order.property":ppt,
			size,
			page
		},
		data
	});
}

//报警详情 
export function baseInfoGet(data){
	return request({
		url:`/maintain-s/operating/alert/detail`,
		method:'post',
		data
	})
}

//报警时间分布图表数据 
export function timelineDataGet(data){
	return request({
		url:`/maintain-s/operating/alert/timeline`,
		method:'post',
		data
	})
}


// WEBPACK FOOTER //
// ./src/api/maintain/alarm/list.js